import React from 'react'
import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../../utilities/currency/formatPrice'
import {formatRoundPrice} from '../../../../utilities/currency/formatPrice'
import yn from 'yn'
import _ from 'lodash'

const BkFlowStructuredSidebarStayTotals = props => {
  const {
    activeCurrencyData,
    activeEnhancementData,
    activeRoomData,
    hotelLabels,
    isTaxInclusiveProperty,
    isMobile,
  } = props

  const addTotals = (a, b) => a + b

  let crsCurrencyCode = null
  let crsCurrencySymbol = null
  let crsGrandTotal = null
  let reservationCurrencyCode = null
  let reservationCurrencySymbol = null
  let reservationRoomTotalData = []
  let reservationRoomTotal = null
  let reservationServicesTotalData = []
  let reservationServicesTotal = null
  let reservationTaxesTotalData = []
  let reservationTaxesTotal = null
  let reservationFeesTotalData = []
  let reservationFeesTotal = null
  let reservationGrandTotalData = []
  let reservationGrandTotal = null

  if (activeRoomData) {
    if (
      activeRoomData &&
      activeRoomData[0][1] &&
      activeRoomData[0][1] &&
      _.get(activeRoomData[0][1], '[0].rates[0].total.currencyCode')
    ) {
      crsCurrencyCode = activeRoomData[0][1][0].rates[0].total.currencyCode
      crsCurrencySymbol = getCurrencySymbol(crsCurrencyCode)

      reservationCurrencyCode = activeRoomData[0][1][0].rates[0].total.currencyCode
      reservationCurrencySymbol = getCurrencySymbol(reservationCurrencyCode)

      if (
        yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
        activeCurrencyData &&
        activeCurrencyData.exchangeRate &&
        activeCurrencyData.currencyCode
      ) {
        reservationCurrencyCode = activeCurrencyData.currencyCode
        reservationCurrencySymbol = getCurrencySymbol(reservationCurrencyCode)
      }
    }

    for (const roomKey in activeRoomData) {
      const currentRoom = activeRoomData[roomKey]

      if (
        currentRoom &&
        currentRoom[1] &&
        _.get(currentRoom[1], '[0].rates[0].total.amountBeforeTax')
      ) {
        if (isTaxInclusiveProperty) {
          reservationRoomTotalData.push(currentRoom[1][0].rates[0].total.amountAfterTax)
        } else {
          reservationRoomTotalData.push(currentRoom[1][0].rates[0].total.amountBeforeTax)
        }
      }

      if (
        currentRoom &&
        currentRoom[1] &&
        _.get(currentRoom[1], '[0].rates[0].total.taxes.amount')
      ) {
        reservationTaxesTotalData.push(currentRoom[1][0].rates[0].total.taxes.amount)
      }

      if (
        currentRoom &&
        currentRoom[1] &&
        _.get(currentRoom[1], '[0].rates[0].total.viewExtensions.fees.amount')
      ) {
        reservationFeesTotalData.push(currentRoom[1][0].rates[0].total.viewExtensions.fees.amount)
      }

      if (
        currentRoom &&
        currentRoom[1] &&
        _.get(currentRoom[1], '[0].rates[0].total.amountAfterTax')
      ) {
        reservationGrandTotalData.push(currentRoom[1][0].rates[0].total.amountAfterTax)
      }
    }

    reservationRoomTotal = reservationRoomTotalData.reduce(addTotals, 0)
    reservationTaxesTotal = reservationTaxesTotalData.reduce(addTotals, 0)
    reservationFeesTotal = reservationFeesTotalData.reduce(addTotals, 0)
  }

  if (activeEnhancementData) {
    for (const enhancementKey in activeEnhancementData) {
      const currentEnhancement = activeEnhancementData[enhancementKey]

      if (
        currentEnhancement.enhancementApiData &&
        currentEnhancement.enhancementApiData.price
      ) {
        for (const enhancementPriceKey in currentEnhancement.enhancementApiData.price) {
          const currentEnhancementPrice = currentEnhancement.enhancementApiData.price[enhancementPriceKey]

          if (
            currentEnhancementPrice.base &&
            currentEnhancementPrice.base.amountAfterTax
          ) {
            reservationServicesTotalData.push(currentEnhancementPrice.base.amountBeforeTax)
          }
        }
      }
    }

    reservationServicesTotal = reservationServicesTotalData.reduce(addTotals, 0)
  }

  if (
    yn(process.env.REACT_APP_COMPONENT_INCLUDE_SERVICES_IN_TOTAL) &&
    reservationServicesTotal
  ) {
    reservationGrandTotalData.push(reservationServicesTotal)
  }

  reservationGrandTotal = reservationGrandTotalData.reduce(addTotals, 0)

  if (String(activeCurrencyData.currencyCode) !== String(crsCurrencyCode)) {
    crsGrandTotal = reservationGrandTotalData.reduce(addTotals, 0)
  }

  // recalculate totals based on selected currency
  // and available exchange rates
  if (
    yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
    activeCurrencyData &&
    activeCurrencyData.exchangeRate &&
    activeCurrencyData.currencyCode
  ) {
    if (reservationRoomTotal) {
      reservationRoomTotal = reservationRoomTotal * activeCurrencyData.exchangeRate
    }

    if (reservationServicesTotal) {
      reservationServicesTotal = reservationServicesTotal * activeCurrencyData.exchangeRate
    }

    if (reservationTaxesTotal) {
      reservationTaxesTotal = reservationTaxesTotal * activeCurrencyData.exchangeRate
    }

    if (reservationFeesTotal) {
      reservationFeesTotal = reservationFeesTotal * activeCurrencyData.exchangeRate
    }

    if (reservationGrandTotal) {
      reservationGrandTotal = reservationGrandTotal * activeCurrencyData.exchangeRate
    }
  }

  return (
    <div className="bk-flow-structured-sidebar__totals">
      <div className="bk-flow-structured-sidebar__row property-stay-line-totals">
        { reservationRoomTotal &&
          <div className="property-stay-room-total">
            <span className="label">
              {hotelLabels.roomTotal ? hotelLabels.roomTotal + ' ' : 'Room Total '}
            </span>
            <span className="value">
              {reservationCurrencySymbol &&
                <span className="currency-symbol">{reservationCurrencySymbol}</span>
              }

              {formatPrice(reservationRoomTotal,2 )}

              {reservationCurrencyCode &&
                <span className="currency-code">&nbsp;{reservationCurrencyCode}</span>
              }
            </span>
          </div>
        }

        { Number(reservationServicesTotal) > 0 &&
          <div className="property-stay-services-total">
            <span className="label">
              {hotelLabels.servicesTotal ? hotelLabels.servicesTotal + ' ' : 'Services Total '}
            </span>
            <span className="value">
              {reservationCurrencySymbol &&
                <span className="currency-symbol">{reservationCurrencySymbol}</span>
              }

              {reservationServicesTotal && formatPrice(reservationServicesTotal,2 )}

              {reservationCurrencyCode &&
                <span className="currency-code">&nbsp;{reservationCurrencyCode}</span>
              }
              </span>
          </div>
        }

        { Number(reservationTaxesTotal) > 0 &&
          <div className="property-stay-taxes-total">
            <span className="label">
              {hotelLabels.taxesTotal ? hotelLabels.taxesTotal + ' ' : 'Taxes Total '}
            </span>
            <span className="value">
              {reservationCurrencySymbol &&
                <span className="currency-symbol">{reservationCurrencySymbol}</span>
              }

              {reservationTaxesTotal && formatRoundPrice(reservationTaxesTotal,2)}

              {reservationCurrencyCode &&
                <span className="currency-code">&nbsp;{reservationCurrencyCode}</span>
              }
            </span>
          </div>
        }

        { Number(reservationFeesTotal) > 0 &&
          <div className="property-stay-fees-total">
            <span className="label">
              {hotelLabels.feesTotal ? hotelLabels.feesTotal + ' ' : 'Fees Total '}
            </span>
            <span className="value">
              {reservationCurrencySymbol &&
                <span className="currency-symbol">{reservationCurrencySymbol}</span>
              }

              {reservationFeesTotal && formatPrice(reservationFeesTotal,2)}

              {reservationCurrencyCode &&
                <span className="currency-code">&nbsp;{reservationCurrencyCode}</span>
              }
            </span>
        </div>
        }
      </div>

      { !isMobile && reservationGrandTotal > 0 &&
        <div className="bk-flow-structured-sidebar__row property-stay-grand-total">
          <h6>
            <span className="label">
              <span className="label-total">{hotelLabels.grandTotal ? hotelLabels.grandTotal + ' ' : 'Grand Total '}</span>
              <span className="label-taxes u-font-xs">({hotelLabels.includingTaxesFees ? hotelLabels.includingTaxesFees : 'Including Taxes & Fees'})</span>
            </span>

            <span className="value">
              <span className="value-reservation">
                {reservationCurrencySymbol &&
                  <span className="currency-symbol">{reservationCurrencySymbol}</span>
                }
                {formatPrice(reservationGrandTotal,2)}

                {reservationCurrencyCode &&
                  <span className="currency-code">&nbsp;{reservationCurrencyCode}</span>
                }
              </span>
              { crsGrandTotal && crsGrandTotal > 0 &&
                <span className="value-crs u-font-xs">
                  (
                  { crsCurrencySymbol &&
                    <span className="currency-symbol">{crsCurrencySymbol}</span>
                  }
                  { crsGrandTotal }
                  { crsCurrencyCode &&
                    <span className="currency-code">&nbsp;{crsCurrencyCode}</span>
                  }
                  )
                </span>
              }
            </span>
          </h6>
        </div>
      }
    </div>
  )
}

export default BkFlowStructuredSidebarStayTotals



// WEBPACK FOOTER //
// ./src/components/structure/sidebar/elements/BkFlowStructuredSidebarStayTotals.js